import { OWNER_CHAR_LIMIT, SEARCH_CHAR_LIMIT, VIOLATIONS_CHAR_LIMIT } from "@lib/shared/models";

const primaryInfo = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'countyId',
            label: 'County',
            validators: { required: true, }
        },
        {
            name: 'docketNumber',
            label: 'Docket Number',
        },
        {
            name: 'dateOfApplication',
            label: 'Date of Application'
        },
        {
            name: 'warrantControlNumber',
            label: 'Warrant Control Number',
        },
        {
            name: 'usePoliceIncidentNumber',
            label: 'Police Incident Number (Other)',
            validators: {}
        },
        {
            name: 'daFileNumber',
            label: 'DA File Number',
        }],
    customFields: []
}

const affiant = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'employeeId',
            label: 'Select an Employee',
            validators: { required: true, }
        },
        {
            name: 'agencyId',
            label: 'Select an Agency',
            validators: { required: true, }
        },
        {
            name: 'phone',
            label: 'Phone',
            validators: {
                required: true,
                pattern: '^\\+?[0-9]{0,3}\\s?\\(?[0-9]{3}\\)?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,7}$'
            }
        },
        {
            name: 'suffix',
            label: 'Ext',
            validators: {
                pattern: '^[x,X]?[0-9]+$',
                maxlength: 20
            }
        },
    ],
    customFields: [
    ]
};

const searchItems = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'searchItems',
            label: 'Identify Items to be Searched for and Seized',
            validators: {
                maxlength: SEARCH_CHAR_LIMIT
            }
        },
        {
            name: 'searchItemsContinued',
            label: '',
            validators: {}
        },
        {
            name: 'addContinuationPage',
            label: 'Add A Continuation Page',
            validators: {}
        }
    ],
    customFields: [
    ]
};

const searchDescription = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'searchDescription',
            label: 'Specific Description of Premises and/or Person to be Searched',
            validators: {
                maxlength: SEARCH_CHAR_LIMIT
            }
        },
        {
            name: 'searchDescriptionContinued',
            label: '',
            validators: {}
        },
        {
            name: 'addContinuationPage',
            label: 'Add A Continuation Page',
            validators: {}
        }
    ],
    customFields: [
    ]
};


const ownerDescription = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'searchOwner',
            label: 'Name of Owner, Occupant or Possessor of Said Premises to be Searched    ',
            validators: {
                maxlength: OWNER_CHAR_LIMIT
            }
        },
        {
            name: 'searchOwnerContinued',
            label: '',
            validators: {}
        },
        {
            name: 'addContinuationPage',
            label: 'Add A Continuation Page',
            validators: {}
        }
    ],
    customFields: [
    ]
};

const violationData = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'occurredFrom',
            label: 'Occurred From',
            validators: {
                required: true
            }
        },

        {
            name: 'occurredTo',
            label: 'Occurred To',
            validators: {}
        },
        {
            name: 'violations',
            label: 'Offenses',
            validators: {
                maxlength: VIOLATIONS_CHAR_LIMIT
            }
        },
        {
            name: 'addContinuationPage',
            label: 'Add A Continuation Page',
            validators: {}
        },
        {
            name: 'violationsContinued',
            label: '',
            validators: {}
        }
    ],
    customFields: [
    ]
};

const confidentialInformation = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'isConfidentialPerson',
            label: 'Has Confidential Information'
        },
        {
            name: 'socialSecurityNumberIdentifierId',
            label: 'Social Security Number',
        },
        {
            name: 'socialSecurityNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'stateIdentifierNumberIdentifierId',
            label: 'State Issued Identification',
        },
        {
            name: 'stateIdentifierNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'financialAccountNumberIdentifierId',
            label: 'Financial Account Number',
        },
        {
            name: 'financialAccountNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'driverLicenseNumberIdentifierId',
            label: 'Driver\'s License',
        },
        {
            name: 'driverLicenseNumberAlternate',
            label: 'Alternate'
        },
        {
            name: 'driverLicenseStateId',
            label: 'State'
        },
        {
            name: 'driverLicenseExpirationDate',
            label: 'Expiration Date'
        },
        {
            name: 'linkDate',
            label: 'Link Date'
        },
        {
            name: 'comment',
            label: 'Comment'
        },
        {
            name: 'isJuvenileRelated',
            label: 'Juvenile Related'
        },
        {
            name: 'juvenileInitials',
            label: 'Juvenile Initials'
        },
        {
            name: 'sequence',
            label: 'Sequence'
        }
    ],
    customFields: [
    ]
};

export const primaryInfoFields = {
    fields: [...primaryInfo.fields],
    customFields: [...primaryInfo.customFields]
}

export const affiantFields = {
    fields: [...affiant.fields],
    customFields: [...affiant.customFields]
};

export const searchItemsFields = {
    fields: [...searchItems.fields],
    customFields: [...searchItems.customFields]
};

export const searchDescriptionFields = {
    fields: [...searchDescription.fields],
    customFields: [...searchDescription.customFields]
};

export const searchOwnerFields = {
    fields: [...ownerDescription.fields],
    customFields: [...ownerDescription.customFields]
};

export const violationDataFields = {
    fields: [...violationData.fields],
    customFields: [...violationData.customFields]
};

export const confidentialInformationFields = {
    fields: [...confidentialInformation.fields],
    customFields: [...confidentialInformation.customFields]
};
